module.exports = __webpack_public_path__ + "static/img/2-0.821017d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star/ej/2-0.png
// module id = 9GT/
// module chunks = 0